module.exports = __webpack_public_path__ + "f0c812dc2400710e5886b266d33a7699.svg";